import request from '@/utils/request2';
export function paidList(data) {
  return request.post('admin/policy/pay-list', data);
}
export function getPayURL(data) {
  return request.post('admin/policy/get-pay-url', data);
}